import SystemCustomDivider from "../../dividers/SystemCustomDivider";
import LevelASubCardHeaderText from "../../texts/levelAScreen/LevelASubCardHeaderText";
import LevelAExampleExplanationText from "../../texts/levelAScreen/LevelAExampleExplanationText";

export default function LevelAExampleExplanation({explanation}) {
    // Used in LevelAExample to display LevelA Knowledge example explanation

    // BUILD
    return (
        <div className={"mt-[12px] bg-primaryDark7/30 border-[1px] border-greyLight1 w-full flex flex-col justify-start items-start px-[16px] pt-[12px] pb-[16px] rounded-[12px]"}>
            <LevelASubCardHeaderText text={"Explications"} />
            <SystemCustomDivider color={"bg-greyLight5"}
                                 extraClass={"mt-[12px]"} />
            <LevelAExampleExplanationText explanation={explanation} />
        </div>
    );
}